import axios from "../../../../configs/axiosIntereptor";
const BASE_URL = process.env.REACT_APP_BASE_URL;

export const getAccountTypeWise = (sFromDate, sToDate) => {
    return axios.get(`${BASE_URL}/api/reports/account-type-wise`, {
        params: { sFromDate: sFromDate, sToDate: sToDate }
    });
};

export const getConnectedProtocols = (sFromDate, sToDate) => {
    return axios.get(`${BASE_URL}/api/reports/connected-protocols`, {
        params: { sFromDate: sFromDate, sToDate: sToDate }
    });
};